import React, { FC } from 'react';

const IconDinero: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      {...props}
    >
      <title>Icon / dinero Copy</title>
      <path
        d="M12,3c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9S16.97,3,12,3z M14.994,9.573
                                      c-0.258-0.382-0.729-0.67-1.134-0.864c-0.404-0.193-0.82-0.291-1.256-0.291c-0.564,0-1.041,0.198-1.436,0.5
                                      c-0.395,0.301-0.688,0.592-0.884,1.367h3.567l-0.574,1.292H10.02c-0.01,0-0.017,0.186-0.019,0.274
                                      c-0.003,0.088-0.004,0.233-0.004,0.409c0,0.064,0.001,0.085,0.004,0.161c0.002,0.076,0.006,0.19,0.011,0.19h2.839l-0.588,1.551
                                      h-1.979c0.221,0.517,0.523,1.043,0.908,1.343c0.385,0.299,0.856,0.446,1.416,0.446c0.437,0,0.844-0.098,1.244-0.291
                                      c0.399-0.193,0.883-0.484,1.141-0.872v2.272c-0.517,0.27-0.845,0.474-1.303,0.61c-0.458,0.138-0.928,0.206-1.418,0.206
                                      c-1.157,0-2.13-0.316-2.921-0.957C8.56,16.281,8,15.454,7.667,14.162H6.232l0.581-1.551h0.647c-0.005,0-0.009-0.086-0.011-0.162
                                      c-0.002-0.057-0.004-0.116-0.004-0.199v-0.093c0-0.143,0.001-0.263,0.004-0.341c0.002-0.079,0.006-0.238,0.011-0.238H6.232
                                      l0.581-1.292h0.854C8.01,8.994,8.575,8.113,9.362,7.48c0.787-0.633,1.759-0.973,2.916-0.973c0.49,0,0.955,0.057,1.413,0.194
                                      s0.786,0.329,1.303,0.598V9.573z"
      />
      <path
        fill="#FFFFFF"
        d="M12,1.18C6.034,1.18,1.18,6.034,1.18,12c0,5.967,4.854,10.82,10.819,10.82S22.819,17.967,22.819,12
	C22.819,6.034,17.966,1.18,12,1.18z M12,21c-4.971,0-9-4.029-9-9s4.029-9,9-9s9,4.029,9,9S16.97,21,12,21z"
      />
      <g>
        <path
          d="M12,3c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9S16.97,3,12,3z M14.994,9.573
		c-0.258-0.382-0.729-0.67-1.134-0.864c-0.404-0.193-0.82-0.291-1.256-0.291c-0.564,0-1.041,0.198-1.436,0.5
		c-0.395,0.301-0.688,0.592-0.884,1.367h3.567l-0.574,1.292H10.02c-0.01,0-0.017,0.186-0.019,0.274
		c-0.003,0.088-0.004,0.233-0.004,0.409c0,0.064,0.001,0.085,0.004,0.161c0.002,0.076,0.006,0.19,0.011,0.19h2.839l-0.588,1.551
		h-1.979c0.221,0.517,0.523,1.043,0.908,1.343c0.385,0.299,0.856,0.446,1.416,0.446c0.437,0,0.844-0.098,1.244-0.291
		c0.399-0.193,0.883-0.484,1.141-0.872v2.272c-0.517,0.27-0.845,0.474-1.303,0.61c-0.458,0.138-0.928,0.206-1.418,0.206
		c-1.157,0-2.13-0.316-2.921-0.957C8.56,16.281,8,15.454,7.667,14.162H6.232l0.581-1.551h0.647c-0.005,0-0.009-0.086-0.011-0.162
		c-0.002-0.057-0.004-0.116-0.004-0.199v-0.093c0-0.143,0.001-0.263,0.004-0.341c0.002-0.079,0.006-0.238,0.011-0.238H6.232
		l0.581-1.292h0.854C8.01,8.994,8.575,8.113,9.362,7.48c0.787-0.633,1.759-0.973,2.916-0.973c0.49,0,0.955,0.057,1.413,0.194
		s0.786,0.329,1.303,0.598V9.573z"
        />
        <path
          d="M12,0C5.383,0,0,5.383,0,12c0,6.617,5.383,12,12,12s12-5.383,12-12C24,5.383,18.617,0,12,0z M12,22.82
		C6.034,22.82,1.18,17.967,1.18,12C1.18,6.034,6.034,1.18,12,1.18S22.819,6.034,22.819,12C22.819,17.967,17.966,22.82,12,22.82z"
        />
      </g>
    </svg>
  );
};

export default IconDinero;
